import { render, staticRenderFns } from "./LoadingOverlay.vue?vue&type=template&id=681413a4&scoped=true&"
import script from "./LoadingOverlay.vue?vue&type=script&lang=js&"
export * from "./LoadingOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681413a4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VCardText,VCardTitle,VOverlay,VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1532393991/src/playtient-web-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('681413a4')) {
      api.createRecord('681413a4', component.options)
    } else {
      api.reload('681413a4', component.options)
    }
    module.hot.accept("./LoadingOverlay.vue?vue&type=template&id=681413a4&scoped=true&", function () {
      api.rerender('681413a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LoadingOverlay.vue"
export default component.exports